let giftProduct = document.querySelector('.giftProduct');

if (giftProduct) {
  window.cartGift = function cartGift(cart, tryProducts) {
    let giftAmount = document.querySelector('.giftProduct__amount').innerText,
        giftProductID = document.querySelector('.giftProduct__id').innerText,
        giftProductPrice = document.querySelector('.giftProduct__price').innerText,
        isGift = false,
        cartPrice = cart.total_price,
        blackCartProductsArray = decodeURIComponent(window.getCookie("bc_variants"));

    cart.items.forEach(product => {
      if (blackCartProductsArray.includes(product.id)) {
        cartPrice = cartPrice - product.price;
      }

      if (product.properties && product.properties._isGift == 'true') {
        isGift = true;
        window.gift_cart_item_added = true;
        giftProductID = product.id;
      }
    });

    if (parseInt(giftAmount) <= cartPrice - parseInt(giftProductPrice) &&
        !isGift && !window.gift_cart_item_added &&
        tryProducts.length <= 0) {
        let progressError = document.querySelector('.minicart__progressError'),
            progressTextMessage = document.querySelector('.minicart__progressTextMessage'),
            progressBar = document.querySelector('.minicart__progress');

        if(progressError.classList.contains('minicart__progressError--showError')) {
          progressError.classList.remove('minicart__progressError--showError');
        }

        if(progressTextMessage.classList.contains('minicart__progressTextMessage--hidden')) {
          progressTextMessage.classList.remove('minicart__progressTextMessage--hidden');
        }

        if(progressBar.classList.contains('minicart__progressError--show')) {
          progressBar.classList.remove('minicart__progressError--show');
        }

        window.addGift(giftProductID);
    } else if (tryProducts.length >= 1 && isGift) {
      window.removeGift(giftProductID);
    } else if (parseInt(giftAmount) > cartPrice - parseInt(giftProductPrice) &&
               isGift && window.gift_cart_item_added) {
        window.removeGift(giftProductID);
    }

    if(tryProducts.length >= 1) {
      let progressError = document.querySelector('.minicart__progressError'),
          progressTextMessage = document.querySelector('.minicart__progressTextMessage'),
          progressBar = document.querySelector('.minicart__progress');

      if(!progressError.classList.contains('minicart__progressError--showError')) {
        progressError.classList.add('minicart__progressError--showError');
      }

      if(!progressTextMessage.classList.contains('minicart__progressTextMessage--hidden')) {
        progressTextMessage.classList.add('minicart__progressTextMessage--hidden');
      }

      if(!progressBar.classList.contains('minicart__progressError--show')) {
        progressBar.classList.add('minicart__progressError--show');
      }
    }
  }

  window.addGift = function addGift(giftProductID) {
    let	formData = {
        items: [{
            id: parseInt(giftProductID),
            quantity: 1,
            properties: {
                '_isGift': 'true'
              }
          },
        ],
      };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify(formData)
    }).then((response) => {
      if (response.ok) {
        window.updatePopUp();
      } else {
        throw new Error();
      }
    }).catch(err => {
      popUpError();
    })
  }

  window.removeGift = function removeGift(giftProductID) {
    formData = {
      updates: {
        [parseInt(giftProductID)]: 0,
      },
    };

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify(formData)
    }).then((response) => {
      if (response.ok) {
        window.gift_cart_item_added = false;
      }
    }).then(() => {
      window.updatePopUp();
    })
  }
}
